import { operators } from './operators';

export interface Rule {
  fact: string;
  operator: keyof typeof operators;
  value?: unknown;
}

export function isRule(obj: unknown): obj is Rule {
  return (
    Object.prototype.hasOwnProperty.call(obj, 'fact') &&
    Object.prototype.hasOwnProperty.call(obj, 'operator')
  );
}
